package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab

import androidx.compose.runtime.Composable
import androidx.compose.runtime.internal.updateLiveLiteralValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.FooterType
import org.hs_soft.runmynesto.domain.model.general.TableColumn
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.SpecialPriceItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.PriceTableHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.PriceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.GetSpecialPrice
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.extractDate
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CustomTable
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.components.SearchBarWithAddEditCloseIcon
import org.hs_soft.runmynesto.pages.components.checkout.CheckoutTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab.component.SelectedPrice
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

@Composable
fun PriceTabContent(
    windowSizeMode: WindowSizeModeEnum,
    specialPrices: List<SpecialPriceItem?>?,
    cashList: List<Children>?,
    profileCountryId:String,
    priceLevels: List<String?>?,
    selectedPrice: GetSpecialPrice?,
    checkoutSearchValue:String,
    onPriceItemClick: (String) -> Unit,
    onDeletePriceIconClick: () -> Unit,
    onAddPriceIconClick:()->Unit,
    onUpdatePriceInfo:(String,dynamic)->Unit,
    updateCheckout:(String,MutableSet<String>)->Unit,
    searchCheckout:(String)->Unit,
    onSearchInPrices:(String)->Unit,
)
{
    Column(
        modifier = VerticalScrollBehavior
            .toModifier()
            .showContentInOnePage()
            .fillMaxWidth()
            .padding(
                bottom = Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    ){
        MediumContentTitle(
            title = Strings.current().general
        )

        SearchBarWithAddEditCloseIcon(
            width = if (windowSizeMode == WindowSizeModeEnum.Desktop)
                Dimen.priceTableWidth else null ,
            searchFieldWidth = Dimen.semiLargeEditTextWidth,
            showEdit = false,
            onSearchInfo ={
                onSearchInPrices(it)
            },
            onAddClick = {
                onAddPriceIconClick()
            },
            onDeleteClick = {
                if (selectedPrice!=null)
                     onDeletePriceIconClick()
            }

        )


        CustomTable(
            modifier = Modifier
                .margin(bottom = Dimen.extraLargePadding),
            height = Dimen.priceTableHeight,
            minHeight = Dimen.priceTableHeight,
            width = if (windowSizeMode == WindowSizeModeEnum.Desktop)
                Dimen.priceTableWidth else null,
            onRowClick = {id,_->
                onPriceItemClick(id)
            },
            selectedId = selectedPrice?.id?:"",
            data = specialPrices?.map { specialPrice ->
                mapOf(
                    "id" to specialPrice?.id,
                    PriceTableHeaderEnum.TYPE.key
                            to specialPrice?.typeName,
                    PriceTableHeaderEnum.START_DATE.key
                            to extractDate(specialPrice?.fromDate?:"") ,
                    PriceTableHeaderEnum.END_DATE.key
                            to extractDate(specialPrice?.toDate?:"") ,
                    PriceTableHeaderEnum.NAME.key
                            to (specialPrice?.name ?: "")
                )
            },
            footerType = FooterType.NONE,
            columns = PriceTableHeaderEnum.entries.map { header ->
                TableColumn(
                    header = header.title,
                    key = header.key,
                    isSortable = true
                )
            },
        )

        if (selectedPrice!=null){
            SelectedPrice(
                windowSizeMode =windowSizeMode,
                selectedPrice =selectedPrice,
                priceLevels =priceLevels ,
                profileCountryId = profileCountryId,
                onUpdatePriceInfo={title:String,value:dynamic->
                    onUpdatePriceInfo(title,value)
                }

            )

            CheckoutTabContent(
                windowSizeMode =windowSizeMode,
                cashList =cashList,
                padding = 0.px,
                borderLess = true,
                height = Dimen.priceContentCheckoutHeight,
                cashRegisterIds =selectedPrice.cashRegisterId,
                updateCheckout = {
                    updateCheckout(ApiUtils.Field.cashRegisterId,it)
                },
                isExpandAll = false,//isCheckoutExpandAll,
                searchValue =checkoutSearchValue,
                onSearchValueChange = {
                    searchCheckout(it)
                },

            )
        }





    }
}